export const isoTimeToDate = (isoTime: string): string => isoTime.split("T")[0];
